export function preparationPieceCount(piecesPerPortion: number | null | undefined, portions: number): number | null {
  return piecesPerPortion != null && Number.isFinite(piecesPerPortion) && piecesPerPortion > 0
    ? piecesPerPortion * portions
    : null;
}

export function formatPreparationQuantity(weight: number, piecesPerPortion: number | null | undefined, portions = 1): string {
  const pieces = preparationPieceCount(piecesPerPortion, portions);
  return `${(weight * portions).toFixed(4)}${pieces != null ? ` / ${Number(pieces.toFixed(4))} шт.` : ''}`;
}
